module.exports = __webpack_public_path__ + "img/activity-dashboard.f30f7ddb.png";